import React, { useEffect, useMemo, useState } from "react";
import { getAttendanceByDateLatest as getAttendanceByDate, getStaffListLatest as getStaffList } from "../../service/apiService";
import "./AttendanceAdmin.css";

const AttendanceAdmin = () => {
  const today = useMemo(() => new Date().toISOString().split("T")[0], []);

  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedStaff, setSelectedStaff] = useState("");

  const [staffList, setStaffList] = useState([]);
  const [attendance, setAttendance] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadStaff();
  }, []);

  useEffect(() => {
    fetchAttendance();
  }, [selectedDate, selectedStaff]);

  const loadStaff = async () => {
    try {
      const res = await getStaffList();
      if (res.success) setStaffList(res.data || []);
    } catch (err) {
      console.log(err);
      alert("Failed to load staff list");
    }
  };

  const fetchAttendance = async () => {
    setLoading(true);
    try {
      const res = await getAttendanceByDate(selectedDate, selectedStaff);
      if (res.success) setAttendance(res.data || []);
      else alert(res.message || "Failed to load attendance");
    } catch (err) {
      console.log(err);
      alert("Failed to load attendance");
    }
    setLoading(false);
  };

  const getStatusClass = (status) => {
    if (status === "ABSENT") return "status-absent";
    if (status === "HALF_DAY") return "status-half";
    return "status-present";
  };

  return (
    <div className="attendance-page">
      <div className="attendance-header">
        <div className="attendance-title">
          <h2>Staff Login / Logout</h2>
          <p>First login and last logout of the selected date</p>
        </div>

        <div className="attendance-filters">
          <div className="date-picker">
            <label>Select Date</label>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>

          <div className="date-picker">
            <label>Filter Staff</label>
            <select
              value={selectedStaff}
              onChange={(e) => setSelectedStaff(e.target.value)}
            >
              <option value="">All Staff</option>
              {staffList.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="attendance-table-wrapper">
        {loading && (
          <div className="attendance-message">Loading attendance…</div>
        )}

        {!loading && attendance.length === 0 && (
          <div className="attendance-message">No staff found</div>
        )}

        {!loading && attendance.length > 0 && (
          <>
            {/* ✅ Desktop Table */}
            <div className="desktop-only">
              <table className="attendance-table">
                <thead>
                  <tr>
                    <th>Staff</th>
                    <th>First Login</th>
                    <th>Last Logout</th>
                    <th>Work Hours</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {attendance.map((row) => (
                    <tr key={row.staff_id}>
                      <td className="staff-name">{row.name}</td>
                      <td>{row.first_login || "-"}</td>
                      <td>{row.last_logout || "-"}</td>
                      <td>{row.work_duration || "-"}</td>
                      <td>
                        <span
                          className={`status-badge ${getStatusClass(
                            row.status
                          )}`}
                        >
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* ✅ Mobile Native Cards */}
            <div className="mobile-only">
              <div>{attendance.length}</div>
              {attendance.map((row) => (
                <div className="att-card" key={row.staff_id}>
                  <div className="att-card-top">
                    <div className="att-name">{row.name}</div>

                    <span
                      className={`status-badge ${getStatusClass(row.status)}`}
                    >
                      {row.status}
                    </span>
                  </div>

                  <div className="att-grid">
                    <div className="att-item">
                      <div className="att-label">First Login</div>
                      <div className="att-value">{row.first_login || "-"}</div>
                    </div>

                    <div className="att-item">
                      <div className="att-label">Last Logout</div>
                      <div className="att-value">{row.last_logout || "-"}</div>
                    </div>

                    <div className="att-item att-item-full">
                      <div className="att-label">Work Hours</div>
                      <div className="att-value">{row.work_duration || "-"}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AttendanceAdmin;
